import { useState } from 'react'
import { Login as SharedLogin } from '@valiant/ui-shared'
import { useAuth } from '../AuthProvider'
import { Auth } from '../auth'

export function Login() {
  const authProvider = useAuth()
  const [authInstance] = useState(() => new Auth())

  return (
    <div className="custom-gradient-background">
      <SharedLogin authInstance={authInstance} authProvider={authProvider} variant="admin" />
    </div>
  )
}
